import { PortalAuthHttpError } from '../error';
import { PortalApiClient } from '../portalApiClient';

import { getMessageFromError } from './errorHelper';
import { LoginModeResponse } from './types';

export async function getLoginMode(
  email: string | null,
  signal: AbortSignal | null,
  client: PortalApiClient
): Promise<LoginModeResponse> {
  try {
    const { data, error, response } = await client.untyped.POST(
      '/auth/login-mode',
      {
        ...(email && { body: { email } }),
        signal,
      }
    );
    if (!response.ok) {
      const message = getMessageFromError(error);
      throw new PortalAuthHttpError(
        message ?? 'Failed requesting user login mode.',
        response.status
      );
    }
    return LoginModeResponse.parse(data);
  } catch (e: unknown) {
    // Do not log errors that caused by an aborted request
    if (!(e instanceof Error && e.name === 'AbortError')) {
      console.error(e);
    }
    throw e;
  }
}
